import { Sliders } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { useBreakpoint } from 'src/hooks';
import { Button } from 'src/v2/commonComponents/Button';
import type { ToggleProps } from 'src/v2/commonComponents/DrawerTooltipContainer';
import styles from './SettingsToggle.module.scss';

interface SettingsToggleProps extends ToggleProps {
  title?: string;
  description?: string;
}

export const SettingsToggle = ({
  title,
  description,
  isActive,
  id,
  disabled,
  onClick,
}: SettingsToggleProps) => {
  const { isDesktopAndUp } = useBreakpoint();

  return (
    <Button
      id={id}
      disabled={disabled}
      color={isActive ? 'tertiary-outline' : 'secondary-outline'}
      onClick={onClick}
      className={styles.root}
      shape={isDesktopAndUp ? 'regular' : 'round'}
    >
      <Sliders size={SVG_SIZE_M} />

      {isDesktopAndUp && (
        <>
          <span>{title}: </span>
          <span className={styles.active}>{description}</span>
        </>
      )}
    </Button>
  );
};
